module.exports = __webpack_public_path__ + "static/media/toys.db25984d.svg";